<template>
    <div class="card text-white bg-info mb-3 mx-auto text-center cardwidth">
        <img :src="require('../assets/'+imgnaam)" class="card-img-top cardimg" :alt="altnaam">
        <div class="card-header">{{header}}</div>
        <div class="card-body">
            <h5 class="card-title">{{titel}}</h5>
            <p class="card-text">
                {{tekst1}}
            </p>
            <p class="card-text">
                {{tekst2}}
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'nieuwsmedewerkers',
        props: ["imgnaam", "altnaam", "header", "titel", "tekst1", "tekst2"],
    }
</script>
<style scoped>
    .cardwidth{
        max-width:300px;
        width: 250px;
    }
    .cardimg{
        height: 200px;
        width: auto;
        margin-left: auto;
        margin-right: auto;
    }
</style>
